import React from 'react';
import styled, { css } from 'styled-components';

const Text = styled.strong`
  color: ${({ theme }) => theme.grey.darker};
  display: block;
  font-weight: 700;
  ${({ $isFloating }) => css`
    font-size: ${!$isFloating ? '16px' : '12px'};
    ${!$isFloating && 'margin-top: 4px;'}
  `}
`;

export const PaymentConditionText = ({ payment, isFloating }) => (
  <Text $isFloating={isFloating}>{payment?.paymentConditionText}</Text>
);
